import {
    CurrencyBangladeshiIcon,
    PlusCircleIcon,
    SquaresPlusIcon,
} from "@heroicons/react/24/outline";
import BusIcon from "../../components/shared/icons/busIcon";
import CanceledCochesIcon from "../../components/shared/icons/canceledCoaches";

const BusBooking = [
    {
        path: "booking",
        fullPath: "call-center/booking",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Bus Booking",
        displayPath: "Call Center > Bus Booking",
        icon: BusIcon,
        children: [
            {
                path: "new",
                fullPath: "call-center/booking/new",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "New",
                displayPath: "Call Center > Bus Booking > New",
                icon: PlusCircleIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Booking/Create"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-bus-booking-create"],
                    },
                ],
            },
            {
                path: "manage",
                fullPath: "call-center/booking/manage",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Manage",
                displayPath: "Call Center > Bus Booking > Manage",
                icon: SquaresPlusIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/Bus"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-bus-booking-manage"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/Details"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["callcenter-bus-booking-manage"],
                    },
                ],
            },
            {
                path: "pending_refunds",
                fullPath: "call-center/booking/pending_refunds",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Pending Refunds",
                displayPath: "Call Center > Bus Booking > Pending Refunds",
                icon: CurrencyBangladeshiIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/Manage/PendingRefunds"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-bus-booking-pending-refunds"],
                    },
                ],
            },
            {
                path: "cancelled-trips",
                fullPath: "call-center/booking/cancelled-trips",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Cancelled Trips",
                displayPath: "Call Center > Bus Booking > Cancelled Trips",
                icon: CanceledCochesIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/CallCenter/Booking/CancelledTrips/List"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["callcenter-bus-booking-cancelled-trips"],
                    },
                ],
            },
        ],
    },
];

export default BusBooking;
